import React from "react";
import { DeploymentCreatorLegacy } from "./DeploymentCreatorLegacy";
import { DeploymentCreatorRegional } from "./DeploymentCreatorRegional";
import type { DeploymentCreatorProps } from "./deploymentCreatorTypes";

export type { DeploymentCreatorProps } from "./deploymentCreatorTypes";

const supportRegionalDeployments =
  process.env.REACT_APP_SUPPORT_REGIONAL_DEPLOYMENTS === "true";

export const DeploymentCreator: React.FC<DeploymentCreatorProps> = (props) => {
  if (!supportRegionalDeployments) {
    return <DeploymentCreatorLegacy {...props} />;
  }

  return <DeploymentCreatorRegional {...props} />;
};
